
export enum Codes {
  ok = 200,
  requireUsername = 460,
  requirePassword = 461,
  requiredNewPassword = 464,
  invalidPassword = 453,
  userNamePasswordNotExist = 454,
  passwordAlreadyExist = 455,
  passwordMatch= 456,
  requiredEmail = 464,
  accountLocked = 458
}



// WEBPACK FOOTER //
// ./src/models/codes.ts